import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["background", "body", "heading", "mediaQuery", "media", "showBody"];
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { UpsellBannerMixin } from '../../mixins/components/UpsellBannerMixin';
import CustomPropTypes from '../../util/custom-prop-types';
import { Banner } from '../Banner/Banner';
import { CloseButton } from '../CloseButton/CloseButton';

/**
 * @extends Banner
 * @since 7.29.0
 */
var UpsellBanner = /*#__PURE__*/styled(function (props) {
  var background = props.background,
    body = props.body,
    heading = props.heading,
    mediaQuery = props.mediaQuery,
    media = props.media,
    showBody = props.showBody,
    rest = _objectWithoutProperties(props, _excluded);
  var renderBody = /*#__PURE__*/React.createElement(Fragment, null, heading, " ", body);
  return /*#__PURE__*/React.createElement(Banner, _extends({
    inverse: false,
    body: renderBody,
    icon: media
  }, rest));
}).withConfig({
  displayName: "UpsellBanner",
  componentId: "c11n-8-111-1__sc-g97c90-0"
})(["", ""], UpsellBannerMixin);
UpsellBanner.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * An optional action button.
   */
  actionButton: PropTypes.node,
  /**
   * Customize the color of the upsell banner.
   * When using the brand background, the text will be inverted.
   */
  background: PropTypes.oneOf(['backgroundBlue', 'backgroundBrand', 'backgroundWhite']),
  /**
   * The body content of the banner message.
   */
  body: PropTypes.node,
  /**
   * In general, you will want to use the `body` prop,
   * but you can use the children prop to override the default component layout.
   * When passing a function, the function will receive all the component props as the only
   * argument (Note: some of the props may have been modified and/or enhanced,
   * so you should always use the values that are passed to the render function).
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * The close button node will always be shown in an UpsellBanner.
   *
   * @ignore
   */
  closeButton: PropTypes.node,
  /**
   * A `Heading` node.
   */
  heading: PropTypes.node,
  /**
   * An UpsellBanner is uncontrolled by default.
   * You can specify `isOpen` to manually control the visibility of the component.
   */
  isOpen: PropTypes.bool,
  /**
   * An `Image` or `Icon` node.
   */
  media: PropTypes.node,
  /**
   * @deprecated Use inline media query objects
   */
  mediaQuery: CustomPropTypes.mediaQuery,
  /**
   * Function called with the `closeButton` is clicked.
   */
  onClose: PropTypes.func,
  /**
   * role is not needed for an UpsellBanner.
   *
   * @ignore
   */
  role: PropTypes.oneOf(['status']),
  /**
   * When true, the body content will be shown right after heading.
   *
   * Supports inline media query objects.
   */
  showBody: CustomPropTypes.inlineMediaQuery(PropTypes.bool)
} : {};
UpsellBanner.defaultProps = {
  background: 'backgroundBlue',
  closeButton: /*#__PURE__*/React.createElement(CloseButton, null),
  heading: null,
  isOpen: null,
  media: null,
  role: null,
  showBody: {
    xs: false,
    md: true
  }
};

/** @component */
export { UpsellBanner };